/**
 * A global namespace for `ArrowUp` key.
 * e.which = 38 equivalent
 */
const keyArrowUp = 'ArrowUp';

export default keyArrowUp;
